(() => {
  window.park.app({
    container: 'third-party-configurator',
    component: 'third-party-configurator',
  });
})();




// WEBPACK FOOTER //
// ./src/widgets/third-party-configurator/third-party-configurator.js